import { render, staticRenderFns } from "./detail-link-payin-trans.vue?vue&type=template&id=35ed0508&scoped=true"
import script from "./detail-link-payin-trans.vue?vue&type=script&lang=js"
export * from "./detail-link-payin-trans.vue?vue&type=script&lang=js"
import style0 from "./detail-link-payin-trans.vue?vue&type=style&index=0&id=35ed0508&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ed0508",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/project/moneypay-web/moneypay-merchant-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35ed0508')) {
      api.createRecord('35ed0508', component.options)
    } else {
      api.reload('35ed0508', component.options)
    }
    module.hot.accept("./detail-link-payin-trans.vue?vue&type=template&id=35ed0508&scoped=true", function () {
      api.rerender('35ed0508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ezpay/online-transaction/detail-link-payin-trans.vue"
export default component.exports